import React from "react"
import List from "../../List/List"
import clsx from "clsx"
import I18n from "i18n-js";


class FormFieldPresenterRatingScale extends React.Component {

  constructor(props) {
    super(props)
  }


  /*** Render Functions ***/

  render() {

    
    var tabClasses = clsx({
      'active': this.props.active_tab == 'rating_scale',
      'tab-pane': true 
    })
    return (
      <div className={tabClasses} id='rating_scale'>
        <div className="row">
          <div className="col-md-3">
            <label>{I18n.t("rating_scale_label")}</label>
            <div>{this.props.rating_scale_label}</div>
          </div>
        </div> 
        <br/>
        <div className="row">
          <div className="col-md-3">
            <label>{I18n.t("rating_scale_range")}</label>
            <div>{this.props.rating_range}</div>
          </div>
        </div>
      </div>
    )
  }

}

export default FormFieldPresenterRatingScale